var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMinthome(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd_214_8740)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#7C4AF1"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_214_8740)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1723 34.9888L34.927 34.8799L35.4173 29.2763L35.5835 29.4743C35.6903 29.6014 35.8432 29.6808 36.0086 29.6952C36.174 29.7095 36.3383 29.6575 36.4653 29.5507C36.5924 29.4439 36.6718 29.291 36.6862 29.1256C36.7005 28.9602 36.6485 28.7959 36.5417 28.6688L29.5568 20.3472C29.3437 20.0934 29.0386 19.9346 28.7085 19.9057C28.3783 19.8768 28.0503 19.9802 27.7964 20.1931L19.4725 27.1755C19.3456 27.2821 19.2662 27.4348 19.2518 27.5999C19.2374 27.7651 19.2893 27.9292 19.3959 28.0561C19.5025 28.1831 19.6552 28.2625 19.8203 28.2769C19.9855 28.2912 20.1496 28.2394 20.2765 28.1328L20.4744 27.9689L19.9841 33.5725L18.7389 33.4636C18.5738 33.4491 18.4096 33.5009 18.2827 33.6074C18.1557 33.714 18.0762 33.8666 18.0618 34.0317C18.0473 34.1969 18.0991 34.361 18.2056 34.488C18.3122 34.6149 18.4648 34.6944 18.6299 34.7088L36.0633 36.2341C36.2285 36.2485 36.3926 36.1968 36.5196 36.0902C36.6465 35.9837 36.726 35.831 36.7404 35.6659C36.7549 35.5008 36.7031 35.3367 36.5966 35.2097C36.49 35.0827 36.3374 35.0033 36.1723 34.9888ZM29.3234 34.3896L25.5877 34.0628L25.9146 30.3271C25.9218 30.2445 25.9615 30.1682 26.025 30.1149C26.0885 30.0616 26.1705 30.0358 26.2531 30.043L29.3662 30.3153C29.4488 30.3226 29.5251 30.3623 29.5784 30.4258C29.6316 30.4893 29.6575 30.5713 29.6503 30.6539L29.3234 34.3896Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M34.6562 35.1071L34.678 34.8581L35.1682 29.2545L35.2209 28.6532L35.6088 29.1156L35.7748 29.3135L34.6562 35.1071ZM34.6562 35.1071L34.9053 35.1289M34.6562 35.1071L34.9053 35.1289M34.9053 35.1289L36.1505 35.2379C36.2496 35.2465 36.3412 35.2942 36.4051 35.3704C36.469 35.4466 36.5001 35.545 36.4914 35.6441C36.4827 35.7432 36.435 35.8348 36.3589 35.8987C36.2827 35.9626 36.1842 35.9937 36.0851 35.985L18.6517 34.4598C18.5526 34.4511 18.4611 34.4034 18.3971 34.3273C18.3332 34.2511 18.3022 34.1526 18.3108 34.0535C18.3195 33.9545 18.3672 33.8629 18.4434 33.7989C18.5196 33.735 18.618 33.704 18.7171 33.7126L19.9623 33.8216L20.2114 33.8434L20.2332 33.5943L20.7234 27.9907L20.7756 27.3949L20.3149 27.7764L20.1171 27.9402L20.1157 27.9414C20.0396 28.0053 19.9411 28.0364 19.842 28.0278C19.7429 28.0192 19.6513 27.9715 19.5873 27.8954C19.5233 27.8192 19.4922 27.7207 19.5009 27.6216C19.5095 27.5225 19.5571 27.4309 19.6333 27.3669L27.957 20.3847C27.957 20.3847 27.957 20.3847 27.957 20.3847C28.1602 20.2143 28.4226 20.1317 28.6867 20.1548C28.9508 20.1779 29.1949 20.3049 29.3653 20.5079C29.3653 20.5079 29.3653 20.5079 29.3654 20.5079L36.3502 28.8296L36.3503 28.8297M34.9053 35.1289L36.3503 28.8297M36.3503 28.8297C36.4145 28.906 36.4457 29.0047 36.4371 29.104C36.4285 29.2033 36.3808 29.2952 36.3045 29.3593C36.2282 29.4235 36.1295 29.4547 36.0302 29.4461C35.9309 29.4375 35.8391 29.3899 35.775 29.3136L36.3503 28.8297ZM29.3017 34.6387L29.5507 34.6605L29.5725 34.4114L29.8993 30.6757C29.9123 30.5271 29.8658 30.3794 29.7699 30.2651C29.674 30.1508 29.5366 30.0793 29.388 30.0663L26.2749 29.7939C26.1263 29.7809 25.9786 29.8275 25.8643 29.9234C25.75 30.0193 25.6785 30.1567 25.6655 30.3053L25.3387 34.041L25.3169 34.2901L25.5659 34.3118L29.3017 34.6387Z",
    stroke: "black",
    strokeWidth: 0.5
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd_214_8740",
    x: -9.53674e-7,
    y: -9.53674e-7,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -2,
    dy: -2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.992157 0 0 0 0 1 0 0 0 0 1 0 0 0 0.8 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_214_8740"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.733333 0 0 0 0 0.764706 0 0 0 0 0.807843 0 0 0 0.6 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow_214_8740",
    result: "effect2_dropShadow_214_8740"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow_214_8740",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_214_8740",
    x: 18.0586,
    y: 19.9009,
    width: 20.6836,
    height: 17.3355,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 2,
    dy: 1
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_214_8740"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_214_8740",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinthome);
export default __webpack_public_path__ + "static/media/minthome.77f8626f9ee1de58ce3fa0ce8825cab6.svg";
export { ForwardRef as ReactComponent };